import React from 'react'

export default function StatementsIcon(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#747894" {...props}>
    <path d="M7 3.5h7.2L19 8.3V19a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 19V5A1.5 1.5 0 0 1 6.5 3.5Z" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M14 3.7V8.5h4.8" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.5 12.5h7M8.5 16h4.5" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
}
